import moment, { Moment } from 'moment'

const createSpanElement = (x: string | null, y: string | null, value: string | number, dy: string) => {
  const tspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan')
  tspan.textContent = value.toString()
  if (x) {
    tspan.setAttribute('x', x)
  }
  if (y) {
    tspan.setAttribute('y', y)
  }

  tspan.setAttribute('dy', dy)
  tspan.classList.add('line')

  return tspan
}

const addTickLabel = (textNode: Element, date: Moment) => {
  const x = textNode.getAttribute('x')
  const y = textNode.getAttribute('y')

  textNode.textContent = ''
  textNode.appendChild(createSpanElement(x, y, date.date(), '0'))
  textNode.appendChild(createSpanElement(x, y, date.format('MMMM'), '16px'))
}

const removeExistingAlertsChildren = (element: Element) => {
  const length = element?.children?.length || 0

  for (let i = 0; i < length; i++) {
    const child = element.children[0]
    if (child) {
      element.removeChild(child)
      removeExistingAlertsChildren(child)
    }
  }
}

// hack to show the month name in first and last tick value
export const formatFirstAndLastTickLabels = (layout: Partial<Plotly.Layout>, graphDiv: Readonly<HTMLElement> | undefined) => {
  if (graphDiv && layout?.xaxis?.range?.length) {
    const allTicks = graphDiv.getElementsByClassName('xtick')
    const allTickLabels: Array<Element> = []

    for (let i = 0; i < allTicks.length; i++) {
      if (allTicks[i].classList.length === 1) {
        allTickLabels.push(allTicks[i])
      }
    }

    const startDate = moment(layout.xaxis.range[0], 'YYYY-MM-DD')
    const endDate = moment(layout.xaxis.range[1], 'YYYY-MM-DD')
    const firstTickTextNode = allTickLabels[0].children[0]
    const lastTickTextNode = allTickLabels[allTickLabels.length - 1].children[0]

    removeExistingAlertsChildren(firstTickTextNode)
    removeExistingAlertsChildren(lastTickTextNode)

    addTickLabel(firstTickTextNode, startDate)
    addTickLabel(lastTickTextNode, endDate)
  }
}
